"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "agoraScreenShareStopped", {
  enumerable: true,
  get: function get() {
    return _agoraScreenShareStopped["default"];
  }
});
var _agoraScreenShareStopped = _interopRequireDefault(require("./agoraScreenShareStopped"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }